function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
var _excluded = ["closeButtonProps", "look"],
  _excluded2 = ["look", "showCloseButton"];
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useContext } from 'react';
import styled, { css, ThemeContext, ThemeProvider } from 'styled-components';
import "../../../../enums/accordion.js";
import "../../../../enums/alert.js";
import "../../../../enums/avatar.js";
import "../../../../enums/breakpoints.js";
import { ButtonLooks } from "../../../../enums/button.js";
import "../../../../enums/code-editor.js";
import "../../../../enums/colors.js";
import "../../../../enums/combobox.js";
import "../../../../enums/date.js";
import "../../../../enums/drag-and-drop.js";
import "../../../../enums/dialog.js";
import "../../../../enums/divider.js";
import "../../../../enums/dropdown.js";
import "../../../../enums/fieldset.js";
import "../../../../enums/font-icon.js";
import "../../../../enums/fonts.js";
import "../../../../enums/headings.js";
import "../../../../enums/input.js";
import "../../../../enums/keys.js";
import "../../../../enums/list.js";
import "../../../../enums/listbox.js";
import "../../../../enums/loader.js";
import "../../../../enums/margin.js";
import "../../../../enums/option.js";
import "../../../../enums/pill.js";
import "../../../../enums/placements.js";
import { PopoutVariants, PopoutLooks } from "../../../../enums/popout.js";
import "../../../../enums/privacy.js";
import "../../../../enums/radio-group.js";
import "../../../../enums/status.js";
import "../../../../enums/switch.js";
import "../../../../enums/table.js";
import "../../../../enums/tooltip.js";
import "../../../../enums/transitions.js";
import "../../../../enums/widths.js";
import "../../../../styles/styled-components/alert.js";
import "../../../../styles/styled-components/animations.js";
import { boxShadowDialogs } from "../../../../styles/styled-components/box-shadow.js";
import "../../../../styles/styled-components/button.js";
import "../../../../themes/alert.js";
import { borderRadiusMedium } from "../../../../themes/borders.js";
import "../../../../themes/button.js";
import "../../../../themes/checkbox.js";
import "../../../../themes/divider.js";
import "../../../../themes/dropdown.js";
import "../../../../themes/fieldset.js";
import { fontFamilyBook } from "../../../../themes/fonts.js";
import "../../../../themes/input.js";
import "../../../../themes/list.js";
import "../../../../themes/listbox.js";
import "../../../../themes/loader.js";
import "../../../../themes/option.js";
import "../../../../themes/popout.js";
import "../../../../themes/switch.js";
import { lightTheme } from "../../../../themes/themes.js";
import "../../../../themes/tooltip.js";
import "../../../../styles/styled-components/font-face.js";
import "../../../../styles/styled-components/global.js";
import "../../../../styles/styled-components/input.js";
import "../../../../styles/styled-components/list.js";
import "../../../../styles/styled-components/listitem.js";
import "../../../../styles/styled-components/media-queries.js";
import "../../../../styles/styled-components/reset.js";
import "../../../../styles/styled-components/outline.js";
import { getPopoutTheme } from "../../../../styles/styled-components/popout.js";
import { screenReaderOnly } from "../../../../styles/styled-components/screen-reader.js";
import "../../../../styles/styled-components/switch.js";
import "../../../../styles/styled-components/tooltip.js";
import { BasePopout } from "../base-popout/base-popout.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var BaseStandardPopout = function BaseStandardPopout(props) {
  var closeButtonProps = props.closeButtonProps,
    look = props.look,
    otherProps = _objectWithoutProperties(props, _excluded);
  var getCloseButtonLook = function getCloseButtonLook() {
    switch (look) {
      case PopoutLooks.Primary:
        {
          return ButtonLooks.White;
        }
      default:
        {
          return ButtonLooks.Default;
        }
    }
  };
  return /*#__PURE__*/React.createElement(BasePopout, _extends({}, otherProps, {
    closeButtonProps: _objectSpread(_objectSpread({}, closeButtonProps), {}, {
      look: getCloseButtonLook()
    }),
    variant: PopoutVariants.Standard
  }));
};
var getCloseButtonPosition = function getCloseButtonPosition(_ref) {
  var title = _ref.title;
  if (!title) {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      position: absolute;\n      right: 10px;\n      top: 10px;\n    "])));
  }
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([""])));
};
var getBodyPadding = function getBodyPadding(_ref2) {
  var showCloseButton = _ref2.showCloseButton,
    title = _ref2.title;
  if (showCloseButton && !title) {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      padding: 15px 35px 15px 20px;\n    "])));
  }
  return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    padding: 20px;\n  "])));
};
var getHeaderStyles = function getHeaderStyles(_ref3) {
  var title = _ref3.title;
  if (title) {
    return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      border-bottom-color: 'transparent';\n      border-bottom-style: solid;\n      border-bottom-width: 1px;\n      display: flex;\n      padding: 15px;\n    "])));
  }
  return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral([""])));
};
var Popout = styled(BaseStandardPopout)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  ", "\n\n  .bf-popout__arrow {\n    height: 8px;\n    width: 15px;\n  }\n\n  .bf-popout__body {\n    ", "\n    overflow: auto;\n  }\n\n  .bf-popout__footer {\n    border-top-color: 'transparent';\n    border-top-style: solid;\n    border-top-width: 1px;\n    display: flex;\n    justify-content: flex-end;\n    padding: 20px;\n  }\n\n  .bf-popout__header {\n    ", "\n    position: relative;\n  }\n\n  .bf-popout__heading {\n    font-family: ", ";\n    font-size: 18px;\n    font-weight: 400;\n    line-height: 24px;\n    overflow-wrap: break-word;\n  }\n\n  .bf-popout__close {\n    ", "\n    font-size: 14px;\n    height: 20px;\n    margin-left: auto;\n    padding: 10px;\n    width: 20px;\n  }\n\n  .bf-popout__close--hidden {\n    ", "\n  }\n\n  .bf-button__close-icon {\n    font-size: 13px;\n  }\n\n  .bf-popout__dialog {\n    z-index: 1;\n  }\n\n  .bf-popout__dialog-inner {\n    ", "\n    border-radius: ", "px;\n    font-family: ", ";\n    font-size: 14px;\n    line-height: 22px;\n    overflow: hidden;\n  }\n\n  .bf-popout__trigger {\n    display: inline-block;\n  }\n"])), function (_ref4) {
  var look = _ref4.look;
  return getPopoutTheme({
    look: look
  });
}, function (_ref5) {
  var showCloseButton = _ref5.showCloseButton,
    title = _ref5.title;
  return getBodyPadding({
    showCloseButton: showCloseButton,
    title: title
  });
}, function (_ref6) {
  var title = _ref6.title;
  return getHeaderStyles({
    title: title
  });
}, fontFamilyBook, function (_ref7) {
  var title = _ref7.title;
  return getCloseButtonPosition({
    title: title
  });
}, screenReaderOnly, boxShadowDialogs, borderRadiusMedium, fontFamilyBook);
/**
 * The difference between tooltips and popouts: Tooltips are meant to be tabbed over, contain only text content (no focusable elements),
 * and use `role="tooltip"`; Popouts are meant to be tabbed in to, can contain focusable elements and text content, and use `role="dialog"`.
 * 
 * Required props include `children`, `content`, `id`, `labels`, `open`, and `setOpen`.
 * All of these props are required for accessibility compliance.
 * 
 * The popout dialog will automatically try and position itself so that it doesn't show off screen 
 * (via the `preventCutoff` prop, which defaults to `true`).
 * 
 * To turn off focus lock, set the `focusLock` prop to `false`. This will turn off users cycling through
 * tabbable elements within the dialog via the `Tab` key. Turning this off is only recommended if your
 * dialog only contains non-tabbable content, such as headings and paragraphs.
 * 
 * You can show a `<CircleLoader>` by setting the `loading` prop to `true` and making sure to pass in
 * `labels.loaderLabel` string.
 * 
 * A popout is a `role="dialog"` with positioning powers. See https://www.w3.org/WAI/ARIA/apg/example-index/dialog-modal/dialog
 * for examples of dialogs.
 * 
 * @example
 * const [open, setOpen] = useState(false);

  const id = 'standard-popout';

  return (
    <StandardPopout
      labels={{
        closeButtonLabel: 'Close',
        loaderLabel: 'Loading'
      }}
      content={<p>Content</p>}
      id={id}
      open={open}
      setOpen={setOpen}
    >
      <StandardButton
        aria-controls={id}
        aria-expanded={open}
        aria-haspopup="dialog"
        onClick={(): void => setOpen(!open)}
      >
        Open popout
      </StandardButton>
    </StandardPopout>
  );
 * @param props StandardPopoutProps
 * @returns FunctionComponent<StandardPopoutProps>
 */
var StandardPopout = function StandardPopout(props) {
  var _props$look = props.look,
    look = _props$look === void 0 ? PopoutLooks.Default : _props$look,
    _props$showCloseButto = props.showCloseButton,
    showCloseButton = _props$showCloseButto === void 0 ? true : _props$showCloseButto,
    otherProps = _objectWithoutProperties(props, _excluded2);
  var themeContext = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: themeContext || lightTheme
  }, /*#__PURE__*/React.createElement(Popout, _extends({}, otherProps, {
    look: look,
    showCloseButton: showCloseButton
  })));
};
export { StandardPopout };